<template>
  <svg id="Camada_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.22 37.22">
    <g id="Camada_1-2" data-name="Camada_1">
      <g>
        <path fill="#fff" d="M.01,20.29c.17,6.86,6.42,16.53,17.81,16.92,10.86.37,19.59-8.23,19.39-19.05C37.01,6.87,27.54.25,20.28.01c0,.39,0,.79,0,1.18,0,5.52,0,11.04,0,16.55,0,1.99-.55,2.54-2.54,2.55-5.52,0-11.04,0-16.55,0H.01ZM16.7,16.72V0C7.87.46.32,8.51,0,16.72h16.7Z"/>
        <path d="M.01,20.29h1.18c5.52,0,11.04,0,16.55,0,1.98,0,2.53-.56,2.54-2.55,0-5.52,0-11.04,0-16.55,0-.39,0-.78,0-1.18,7.26.24,16.73,6.86,16.94,18.15.2,10.81-8.53,19.42-19.39,19.05C6.43,36.82.18,27.15.01,20.29Z"/>
        <path d="M16.7,16.72H0C.32,8.51,7.87.46,16.7,0v16.72Z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'FinanceIcon'
}
</script>
